import React from "react";
import { TournamentResultsTable } from "../TournamentResultsTable";

const TournamentResultsContent = ({
  filteredResults,
  getPaginatedEventData,
  eventPagination,
  serverShowPayouts,
  tournamentId,
  handlePageChange,
  handleItemsPerPageChange,
  allResults, // Keep this for getting event names
}) => {
  // Get unique events from FILTERED results only - hide empty events
  const uniqueEvents = [
    ...new Set(filteredResults.map((team) => team.eventId)),
  ];

  if (uniqueEvents.length === 0) {
    return (
      <section
        className="card-board text-center py-12"
        role="status"
        aria-label="No results found"
      >
        <h3 className="heading-display text-lg mb-2">No results found</h3>
        <p className="text-brand-muted">
          Try a different search or event filter.
        </p>
        <div className="sr-only" aria-live="polite">
          No tournament results match your current search criteria. Please try
          different search terms or remove some filters.
        </div>
      </section>
    );
  }

  return (
    <main role="main" aria-label="Tournament results by event">
      {uniqueEvents.map((eventId) => {
        // Get teams for this specific event from filtered results
        const eventTeams = filteredResults.filter(
          (team) => team.eventId === eventId
        );

        const eventName =
          allResults.find((team) => team.eventId === eventId)?.eventName ||
          "Unknown Event";
        const paginatedEventTeams = getPaginatedEventData(eventId, eventTeams);

        return (
          <section
            key={eventId}
            className="card-board overflow-hidden mb-6"
            role="region"
            aria-labelledby={`event-heading-${eventId}`}
            aria-label={`${eventName} results`}
          >
            <div className="px-4 sm:px-6 pt-4 pb-2">
              <h2
                id={`event-heading-${eventId}`}
                className="heading-display text-lg sm:text-xl"
              >
                {eventName}
              </h2>
            </div>

            {/* Screen reader announcement for event results */}
            <div className="sr-only" aria-live="polite">
              {eventName}: {eventTeams.length} teams or bowlers found.
            </div>

            <TournamentResultsTable
              key={eventId}
              eventData={paginatedEventTeams}
              showPayouts={serverShowPayouts}
              tournamentId={tournamentId}
              onPageChange={(newPage) => handlePageChange(eventId, newPage)}
              onItemsPerPageChange={(newItemsPerPage) =>
                handleItemsPerPageChange(eventId, newItemsPerPage)
              }
              pagination={eventPagination[eventId]}
              eventName={eventName}
              eventId={eventId}
            />
          </section>
        );
      })}
    </main>
  );
};

export default TournamentResultsContent;
